import {CPaymentLinkStatuses} from '@/app/main/paymentLink/models/constants/paymentLink.constants';
import {CBankingErrorCodes} from '@/utils/errors/codes/banking.codes';

import {IPaymentLinkInformation} from '../entities';

export const CHttpStatusCodes = {
  NETWORK_ERROR: 0,
} as const;

export const mapErrorToPaymentLinkInfo = (
  id: string,
  error: any,
): IPaymentLinkInformation => {
  const base: IPaymentLinkInformation = {
    id,
    single_payment: false,
    receiver_user: null,
    status: CPaymentLinkStatuses.ERROR,
    link_consumed: false,
  };

  const errors: Array<{code: string}> = error?.data?.errors || [];
  if (
    errors.some(
      e => e.code === CBankingErrorCodes.BANKING_REQUEST_MONEY_LINK_NOT_FOUND,
    )
  ) {
    return {...base, status: CPaymentLinkStatuses.NOT_VALID};
  }

  return base;
};

export const transformPaymentLinkInformationWithError = (
  id: string,
  error: any,
): IPaymentLinkInformation => {
  const payment: IPaymentLinkInformation = {
    id,
    single_payment: false,
    receiver_user: null,
    status: CPaymentLinkStatuses.ERROR,
    link_consumed: false,
  };

  if (error?.status !== CHttpStatusCodes.NETWORK_ERROR) {
    const errors: Array<{code: string}> = error?.data?.errors || [];
    if (
      errors.some(
        e => e.code === CBankingErrorCodes.BANKING_REQUEST_MONEY_LINK_NOT_FOUND,
      )
    ) {
      payment.status = CPaymentLinkStatuses.NOT_VALID;
    }
  }

  return payment;
};
